import { appendScript } from "../shared/requests";
import { billingHistoryUserPath } from "routes";
import { Flash } from "jose_modern/flash";
import { once } from "~/jose_modern/once";

async function refreshBillingTable(container = document.querySelector("[data-billing-history]")) {
  const table = container.querySelector("#invoice-table");
  const loading = container.querySelector("#invoice-loading");
  const invoiceYearSelect = container.querySelector("#invoice-year");
  const invoiceYear = invoiceYearSelect.value;
  const userID = container.dataset.userId;

  try {
    loading.classList.remove("is-hidden");
    table.classList.add("is-hidden");

    const response = await fetch(billingHistoryUserPath(userID, { invoice_year: invoiceYear }), {
      headers: { Accept: "application/javascript" },
    });

    if (response.status !== 200) {
      throw new Error("Invalid response from server");
    }

    appendScript(await response.text());
  } catch {
    Flash.create(
      "Oh no, something went wrong fetching your billing information! Please try again!"
    );
  } finally {
    loading.classList.add("is-hidden");
    table.classList.remove("is-hidden");
  }
}

export function initBillingHistory(container = document) {
  const invoiceYearSelect = container.getElementById("invoice-year");
  once(invoiceYearSelect, "billing-history", () => {
    invoiceYearSelect.addEventListener("change", () => {
      refreshBillingTable();
    });
  });
}

export function fetchBillingHistory() {
  refreshBillingTable();
}
